import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiFileText, FiBook, FiMessageSquare, FiShield, FiGlobe, FiArrowRight } from 'react-icons/fi';
import PageMeta from '../components/PageMeta';

const features = [
  { icon: FiHome, title: 'Logements sécurisés', desc: 'Trouvez un logement vérifié près de l\'université', to: '/logements' },
  { icon: FiFileText, title: 'Suivi des démarches', desc: 'Suivez vos démarches administratives en temps réel', to: '/demarches' },
  { icon: FiBook, title: 'Guide de Kolwezi', desc: 'Informations pratiques sur la ville et ses services', to: '/guide' },
  { icon: FiMessageSquare, title: 'Messagerie intégrée', desc: 'Communiquez avec les propriétaires et l\'administration', to: '/messages' },
  { icon: FiShield, title: 'Accompagnement', desc: 'Un accompagnement personnalisé pour votre installation', to: '/dashboard' },
  { icon: FiGlobe, title: 'Communauté', desc: 'Rejoignez une communauté d\'étudiants internationaux', to: '/communautes' },
];

const stats = [
  { number: '50+', label: 'LOGEMENTS DISPONIBLES' },
  { number: '4', label: 'TYPES DE DÉMARCHES' },
  { number: '8', label: 'CATÉGORIES DU GUIDE' },
  { number: '24/7', label: 'SUPPORT' },
];

export default function HomePage() {
  return (
    <div>
      <PageMeta title="Accueil" description="Votre plateforme tout-en-un pour une installation réussie à Kolwezi. Logements, démarches administratives, guide de la ville." />
      <section style={{ backgroundColor: '#0A192F' }}>
        <div className="page-container py-20 md:py-28">
          <div className="max-w-3xl">
            <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight text-white tracking-tight">
              Bienvenue à l'<span style={{ color: '#C59B6C' }}>UNIKOL</span>
            </h1>
            <p className="mt-6 text-lg md:text-xl max-w-2xl" style={{ color: '#88929B' }}>
              Votre plateforme tout-en-un pour une installation réussie à Kolwezi.
              Logement, démarches administratives, guide de la ville — tout au même endroit.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/register" className="px-8 py-4 text-base font-bold tracking-wider uppercase inline-flex items-center gap-2"
                style={{ backgroundColor: '#C59B6C', color: '#0A192F', borderRadius: 0 }}>
                Commencer <FiArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/guide" className="px-8 py-4 text-base font-bold tracking-wider uppercase border-2 inline-flex items-center gap-2"
                style={{ color: '#FFFFFF', borderColor: '#FFFFFF', borderRadius: 0 }}>
                Explorer le guide <FiArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="page-container py-16 md:py-24">
        <h2 className="font-serif text-3xl font-bold text-center tracking-tight" style={{ color: '#0A192F' }}>
          Tout ce dont vous avez besoin
        </h2>
        <p className="mt-4 text-center text-sm max-w-2xl mx-auto" style={{ color: '#7A828A' }}>
          Une plateforme complète pour faciliter votre intégration à l'Université de Kolwezi.
        </p>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map(({ icon: Icon, title, desc, to }) => (
            <Link key={title} to={to} className="card-root p-6 hover:shadow-md transition-shadow block group">
              <div className="w-12 h-12 flex items-center justify-center mb-4" style={{ backgroundColor: '#F4F4F0' }}>
                <Icon className="w-6 h-6" style={{ color: '#C59B6C' }} />
              </div>
              <h3 className="font-serif text-lg font-bold" style={{ color: '#0A192F' }}>{title}</h3>
              <p className="mt-2 text-sm" style={{ color: '#7A828A' }}>{desc}</p>
              <div className="mt-4 flex items-center gap-1 text-xs font-bold tracking-widest uppercase transition-all group-hover:gap-2" style={{ color: '#C59B6C' }}>
                Explorer <FiArrowRight className="w-3 h-3" />
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section style={{ backgroundColor: '#0A192F' }}>
        <div className="page-container py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {stats.map(({ number, label }) => (
              <div key={label}>
                <div className="font-serif text-4xl font-bold" style={{ color: '#C59B6C' }}>{number}</div>
                <div className="mt-2 text-[11px] font-semibold tracking-widest uppercase" style={{ color: '#7A828A' }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page-container py-16 md:py-24 text-center">
        <h2 className="font-serif text-3xl font-bold tracking-tight" style={{ color: '#0A192F' }}>Prêt à commencer ?</h2>
        <p className="mt-4 text-sm max-w-xl mx-auto" style={{ color: '#7A828A' }}>
          Créez votre compte et accédez à tous les services de la plateforme..
        </p>
        <div className="mt-8 flex justify-center gap-4">
          <Link to="/register" className="px-8 py-4 text-base font-bold tracking-wider uppercase inline-flex items-center gap-2"
            style={{ backgroundColor: '#C59B6C', color: '#0A192F', borderRadius: 0 }}>
            S'inscrire <FiArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/login" className="px-8 py-4 text-base font-bold tracking-wider uppercase inline-flex items-center gap-2 border-2"
            style={{ color: '#0A192F', borderColor: '#0A192F', borderRadius: 0 }}>
            Se connecter <FiArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
